import { apiClient } from '~/api/client';

export const index = () => apiClient.get('/trends');
